import { getApi } from '../../components/Shared/shared';
const baseURL = getApi();

export const choicesUrl = {
  choices: `${baseURL}/choices`
};

export default choicesUrl;
